// src/assets/mockdata/Patient/mockPatients.ts

import { Patient } from '@dataTypes/PatientInfo.types'

export const mockPatients: Patient[] = [
  {
    patient_id: 'XCP874954',
    first_name: 'John',
    middle_name: 'W.',
    last_name: 'Doe',
    date_of_birth: '1990-01-01',
    address: '123 Main St, Springfield IL',
    city: 'Springfield',
    state: 'IL',
    zip: '62704',
    gender: 'Male',
    marital_status: 'Single',
    profession: 'Engineer',
    company_name: 'Tech Corp',
    cellphone: '+19492289834',
    email: 'john.doe@email.com',
    allergy_ids: ['mock-allergy-0', 'mock-allergy-1', 'mock-allergy-2'],
    patient_allergies: [
      {
        allergy_id: 'mock-allergy-0',
        allergy: { allergy_id: 'mock-allergy-0', title: 'Penicillin' },
      },
      {
        allergy_id: 'mock-allergy-1',
        allergy: { allergy_id: 'mock-allergy-1', title: 'Latex' },
      },
      {
        allergy_id: 'mock-allergy-2',
        allergy: { allergy_id: 'mock-allergy-2', title: 'Shellfish' },
      },
    ],
    medical_condition_ids: [
      'mock-condition-0',
      'mock-condition-1',
      'mock-condition-2',
    ],
    patient_medical_conditions: [
      {
        medical_condition_id: 'mock-condition-0',
        medical_condition: {
          medical_condition_id: 'mock-condition-0',
          title: 'Hypertension',
        },
      },
      {
        medical_condition_id: 'mock-condition-1',
        medical_condition: {
          medical_condition_id: 'mock-condition-1',
          title: 'Diabetes Type 2',
        },
      },
      {
        medical_condition_id: 'mock-condition-2',
        medical_condition: {
          medical_condition_id: 'mock-condition-2',
          title: 'Asthma',
        },
      },
    ],
    insurance_provider: 'Blue Cross Blue Shield',
    policy_number: 'ABC12345',
    insurance_expiry_date: '2025-01-01',
    family_members: 'Yes',
    join_referral_program: true,
    preferred_appointment_time: '9AM - 11AM',
    contact_via: ['Phone', 'Email'],
    preferred_provider: 'Dr. Smith',
    preferred_hygienist: 'N/A',
    notes: '',
    uploadedFiles: [],
    template: '',
    photo: 'https://cdn-icons-png.flaticon.com/512/15735/15735364.png',
    patient_status: 19,
    date_first_visit: '2023-12-01',
    date_previous_visit: '2023-12-01',
    date_next_visit: '2024-06-15',
    balance_due: 0,
    has_insurance: true,
    contact_via_phone: true,
    contact_via_sms: true,
    contact_via_email: true,
    contact_via_app: true,
    is_subscribed: true,
    membership_type: 'Gold',
  },
  {
    patient_id: 'XCP224954',
    first_name: 'Jane',
    middle_name: 'A.',
    last_name: 'Smith',
    date_of_birth: '1985-03-15',
    address: '456 Elm St, Springfield IL',
    city: 'Springfield',
    state: 'IL',
    zip: '62704',
    gender: 'Female',
    marital_status: 'Married',
    profession: 'Teacher',
    company_name: 'Springfield High',
    cellphone: '(555) 123-4567',
    email: 'jane.smith@email.com',
    allergy_ids: ['mock-allergy-0'],
    patient_allergies: [
      {
        allergy_id: 'mock-allergy-0',
        allergy: { allergy_id: 'mock-allergy-0', title: 'Peanuts' },
      },
    ],
    medical_condition_ids: ['mock-condition-0'],
    patient_medical_conditions: [
      {
        medical_condition_id: 'mock-condition-0',
        medical_condition: {
          medical_condition_id: 'mock-condition-0',
          title: 'Asthma',
        },
      },
    ],
    insurance_provider: 'HealthFirst',
    policy_number: 'XYZ67890',
    insurance_expiry_date: '2024-10-20',
    family_members: 'Yes',
    join_referral_program: false,
    preferred_appointment_time: '2PM - 4PM',
    contact_via: ['Phone'],
    preferred_provider: 'Dr. Brown',
    preferred_hygienist: 'N/A',
    notes: 'Prefers afternoon appointments.',
    uploadedFiles: [],
    template: '',
    photo: 'https://cdn-icons-png.flaticon.com/512/417/417776.png',
    patient_status: 19,
    date_first_visit: '2023-11-05',
    date_previous_visit: '2023-11-20',
    date_next_visit: '2024-05-10',
    balance_due: 100,
    has_insurance: true,
    contact_via_phone: true,
    contact_via_sms: true,
    contact_via_email: true,
    contact_via_app: true,
    membership_type: 'Silver',
  },
  {
    patient_id: 'XCP555954',
    first_name: 'Michael',
    middle_name: 'B.',
    last_name: 'Johnson',
    date_of_birth: '1978-07-22',
    address: '789 Maple St, Springfield IL',
    city: 'Springfield',
    state: 'IL',
    zip: '62704',
    gender: 'Male',
    marital_status: 'Divorced',
    profession: 'Accountant',
    company_name: 'Financial Solutions',
    cellphone: '(555) 123-4567',
    email: 'michael.j@email.com',
    allergy_ids: [],
    patient_allergies: [],
    medical_condition_ids: ['mock-condition-0'],
    patient_medical_conditions: [
      {
        medical_condition_id: 'mock-condition-0',
        medical_condition: {
          medical_condition_id: 'mock-condition-0',
          title: 'Hypertension',
        },
      },
    ],
    insurance_provider: 'SecureHealth',
    policy_number: 'LMN45678',
    insurance_expiry_date: '2025-06-30',
    family_members: 'Yes',
    join_referral_program: true,
    preferred_appointment_time: '11AM - 1PM',
    contact_via: ['Email'],
    preferred_provider: 'Dr. Green',
    preferred_hygienist: 'N/A',
    notes: 'Requires blood pressure monitoring.',
    uploadedFiles: [],
    template: '',
    photo: 'https://cdn-icons-png.flaticon.com/512/15735/15735364.png',
    patient_status: 19,
    date_first_visit: '2023-10-15',
    date_previous_visit: '2023-10-30',
    date_next_visit: '2024-04-20',
    balance_due: 250,
    has_insurance: true,
    contact_via_phone: true,
    contact_via_sms: true,
    contact_via_email: true,
    contact_via_app: true,
    membership_type: 'Bronze',
  },
  {
    patient_id: 'XCP777954',
    first_name: 'Emily',
    middle_name: 'C.',
    last_name: 'Davis',
    date_of_birth: '1992-05-12',
    address: '321 Oak St, Springfield IL',
    city: 'Springfield',
    state: 'IL',
    zip: '62704',
    gender: 'Female',
    marital_status: 'Single',
    profession: 'Software Developer',
    company_name: 'Tech Innovators',
    cellphone: '(555) 123-4567',
    email: 'emily.davis@email.com',
    allergy_ids: [],
    patient_allergies: [],
    medical_condition_ids: ['mock-condition-0'],
    patient_medical_conditions: [
      {
        medical_condition_id: 'mock-condition-0',
        medical_condition: {
          medical_condition_id: 'mock-condition-0',
          title: 'Diabetes',
        },
      },
    ],
    insurance_provider: 'HealthPlus',
    policy_number: 'DEF12345',
    insurance_expiry_date: '2024-12-31',
    family_members: 'None',
    join_referral_program: true,
    preferred_appointment_time: '1PM - 3PM',
    contact_via_phone: false,
    contact_via_sms: true,
    contact_via_email: false,
    contact_via_app: true,
    preferred_provider: 'Dr. White',
    preferred_hygienist: 'N/A',
    notes: 'Prefers digital communication.',
    uploadedFiles: [],
    template: '',
    photo: 'https://cdn-icons-png.flaticon.com/512/3233/3233515.png',
    patient_status: 19,
    date_first_visit: '2023-09-10',
    date_previous_visit: 'N/A',
    date_next_visit: '2024-03-25',
    balance_due: 0,
    has_insurance: true,
    contact_via: ['Phone', 'Email'],
    membership_type: 'Basic',
  },
  {
    patient_id: 'XCP111954',
    first_name: 'Robert',
    middle_name: 'D.',
    last_name: 'Miller',
    date_of_birth: '1982-12-03',
    address: '654 Pine St, Springfield IL',
    city: 'Springfield',
    state: 'IL',
    zip: '62704',
    gender: 'Male',
    marital_status: 'Married',
    profession: 'Construction Manager',
    company_name: 'BuildRight',
    cellphone: '(555) 123-4567',
    email: 'robert.miller@email.com',
    allergy_ids: ['mock-allergy-0'],
    patient_allergies: [
      {
        allergy_id: 'mock-allergy-0',
        allergy: { allergy_id: 'mock-allergy-0', title: 'Dust' },
      },
    ],
    medical_condition_ids: ['mock-condition-0'],
    patient_medical_conditions: [
      {
        medical_condition_id: 'mock-condition-0',
        medical_condition: {
          medical_condition_id: 'mock-condition-0',
          title: 'Arthritis',
        },
      },
    ],
    insurance_provider: 'MediCover',
    policy_number: 'GHI67890',
    insurance_expiry_date: '2025-08-15',
    family_members: 'None',
    join_referral_program: false,
    preferred_appointment_time: '10AM - 12PM',
    contact_via: ['Phone', 'Email'],
    preferred_provider: 'Dr. Blue',
    preferred_hygienist: 'N/A',
    notes: 'Prefers morning appointments.',
    uploadedFiles: [],
    template: '',
    photo: 'https://cdn-icons-png.flaticon.com/512/15735/15735374.png',
    patient_status: 19,
    date_first_visit: '2023-08-20',
    date_previous_visit: '2023-09-05',
    date_next_visit: '2024-02-15',
    balance_due: 50,
    has_insurance: true,
    contact_via_phone: true,
    contact_via_sms: true,
    contact_via_email: true,
    contact_via_app: true,
    membership_type: 'Silver',
  },
]
